import React from 'react';
//todo use compiled when @atlaskit/image supports it
//the image is moved to a separate file due to
//https://atlassian.slack.com/archives/CFJ9DU39U/p1691750071893489
import css from '@emotion/css';

import Image from '@atlaskit/image';

import GuestOnboardingImageLight from './img/Guest-Onboarding-Light.svg';
import GuestOnboardingImageDark from './img/Guest-Onboarding-Dark.svg';

const imageStyles = css`
	width: 74%;
	margin-top: 5%;
	margin-left: 12%;
	height: 75%;
	object-fit: contain;
	object-position: center;
`;

type ImageProps = {
	alt: string;
};

export function GuestOnboardingModalImage({ alt }: ImageProps) {
	return (
		<Image
			alt={alt}
			src={GuestOnboardingImageLight}
			srcDark={GuestOnboardingImageDark}
			css={imageStyles}
		/>
	);
}
